import { createExperiments } from '@cbhq/experiments';

export const workspaceExperimentConfig = {
  // workspace_audit_log
  t0018_aac156e2: ['control', 'treatment'] as const,
  // workspace_consensus
  t0018_7b870e9f: ['control', 'treatment'] as const,
  // workspace_settings
  t0018_3ab23203: ['control', 'treatment'] as const,
  // workspace_member_management_step_up
  t0018_c2608c57: ['control', 'treatment'] as const,
  // workspace_domain_claims
  t0018_1a1ab525: ['control', 'treatment'] as const,
  // workspace_admin_access_cooldown (IDFE-4020): gates the FE for the 48-hour
  // admin grace period — pending role display and cancel, protected-role
  // warnings, and pending-aware manage permissions. Control must behave exactly
  // as today.
  t0018_4fba688a: ['control', 'treatment'] as const,
} as const;

const AppExperiments = createExperiments(workspaceExperimentConfig);

export default AppExperiments;
